import { useCallback, useEffect, useState } from "react";
import { userApi } from "../services/api";

/**
 * The signed-in account as the API sees it (id, username, kind, is_staff).
 * The JWT carries id and username but not staff status, and staff status
 * decides which controls a page may offer — so ask the server once.
 */
const useMe = () => {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMe = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await userApi.me();
      setMe(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  // Apply a change the server already confirmed (e.g. a new avatar_url from
  // the PUT) without a refetch: `refresh` flips `loading`, and while it's
  // true AppShell hides the Agents nav and AgentRoutes unmounts its page —
  // a one-time token screen included (S5 review B1).
  const update = useCallback(
    (patch) => setMe((prev) => (prev ? { ...prev, ...patch } : prev)),
    [],
  );

  return { me, loading, error, refresh: fetchMe, update };
};

export default useMe;
